import { render, staticRenderFns } from "./chess-board-rate.vue?vue&type=template&id=01f3d158&scoped=true&"
import script from "./chess-board-rate.vue?vue&type=script&lang=js&"
export * from "./chess-board-rate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f3d158",
  null
  
)

export default component.exports